// Environment detection
const isDevelopment = process.env.NODE_ENV === 'development';

// Base API URLs
const DEV_API_BASE_URL = 'http://localhost:5001/api';
const PROD_API_BASE_URL = 'https://textly-backend-production.up.railway.app/api';

// Select the appropriate base URL based on environment
const API_BASE_URL = isDevelopment ? DEV_API_BASE_URL : PROD_API_BASE_URL;

export const apiRequest = async (endpoint, options = {}) => {
    // Set up default headers with authentication tokens
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Refresh-Token': localStorage.getItem('refreshToken'),
      ...options.headers
    };
  
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers
      });
  
      // Check for new tokens in response headers
      const newAccessToken = response.headers.get('New-Access-Token');
      const newRefreshToken = response.headers.get('New-Refresh-Token');
      
      if (newAccessToken && newRefreshToken) {
        console.log('New tokens received:', newAccessToken, newRefreshToken);
        localStorage.setItem('token', newAccessToken);
        localStorage.setItem('refreshToken', newRefreshToken);
      }
  
      // Handle authentication errors
      if (response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('mongoToken');
        // Redirect to login or handle as needed
        throw new Error('Authentication failed');
      }
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'API request failed');
      }
  
      return await response.json();
    } catch (error) {
      console.error('API request error:', error);
      throw error;
    }
  };


export { API_BASE_URL };